import { createFeatureSelector, createSelector } from '@ngrx/store';

import { AuthState, AUTH_FEATURE_KEY } from './auth.state';

export const authQuery = createFeatureSelector<AuthState>(AUTH_FEATURE_KEY);
export const user = (state: AuthState) => state.user;
export const sessionEntries = (state: AuthState) => state.user.sessionEntries;

export const selectIsLoggedIn = createSelector(
    authQuery,
    state => state.isLoggedIn
);

export const selectIsLoggedInChecked = createSelector(
    authQuery,
    state => state.isLoggedInChecked
);

export const selectLoginError = createSelector(
    authQuery,
    state => state.hasLoginError
);

export const selectIsLoadingLogin = createSelector(
    authQuery,
    state => state.isLoadingLogin
);

export const getFirstClub = createSelector(
    authQuery,
    state => state.user?.firstClub
);

export const selectAuthUser = createSelector(
    authQuery,
    state => state.user
);

export const selectSession = createSelector(
    authQuery,
    state => state.user?.sessionEntries ?? []
);

export const getHeaderMenu2 = createSelector(
    authQuery,
    state => state.user?.headerMenu2 ?? []
);

export const getData = (name: string, srcpath: string) => createSelector(
    authQuery,
    (state: AuthState) => {
        var obj = state.user.sessionEntries.find(c => (c.name as string).toLowerCase() === name.toLowerCase())?.value;
        if (obj) {
            if (srcpath !== '.' && srcpath !== '') {
                for (var i = 0, path = srcpath.split('.'), len = path.length; i < len; i++) {
                    obj = obj[path[i]];
                }
            }
            return obj;
        }
        else {
            return null;
        }
    }
);

export const selectHeaderMenu2 = createSelector(
    authQuery,
    (state: AuthState) => state.user?.headerMenu2 ?? []
);

export const selectHeaderMenu2FromRoot =
    createSelector(
        selectHeaderMenu2,
        (headerMenu2) => {
            return headerMenu2.filter(c => (c.ParentId ?? 0) == 0).sort((a,b)=> a.SortOrder - b.SortOrder);
        }
    );

export const selectHeaderMenu2FromParentId = (parentId: number) =>
    createSelector(
        selectHeaderMenu2,
        (headerMenu2) => {
            return headerMenu2.filter(c => c.ParentId == parentId).sort((a,b) => a.SortOrder - b.SortOrder);
        }
    );